export default {
  system: {
    name: 'Hệ thống quản lý',
    language: 'Ngôn ngữ',
    theme: 'Giao diện'
  },
  auth: {
    login: 'Đăng nhập',
    adminPanel: 'Bảng điều khiển quản trị',
    phone: 'Số điện thoại',
    password: 'Mật khẩu',
    signIn: 'Đăng nhập',
    logout: 'Đăng xuất',
    confirmLogout: 'Xác nhận đăng xuất',
    confirmLogoutText: 'Bạn có chắc chắn muốn đăng xuất không?',
    loginError: 'Đăng nhập thất bại. Vui lòng kiểm tra email và mật khẩu.',
    forgotPassword: 'Nếu bạn không biết cách đăng nhập hoặc quên mật khẩu,',
    contactSupport: 'vui lòng liên hệ với công ty Lockerbot tại:'
  },
  dashboard: {
    title: 'Bảng điều khiển',
    user: 'Người dùng',
    goodMorning: 'Chào buổi sáng',
    goodAfternoon: 'Chào buổi chiều',
    goodEvening: 'Chào buổi tối',
    welcomeMessage: 'Chào mừng đến với Bảng điều khiển LockerBot. Tại đây bạn có thể quản lý gói hàng, người dùng và cài đặt.',
    profile: 'Hồ sơ của tôi',
    profileTitle: 'Hồ sơ người dùng',
    viewAllActive: 'Xem tất cả các gói đang hoạt động',
    viewAllExpired: 'Xem tất cả các gói đã hết hạn',
    viewAllFinished: 'Xem tất cả các gói đã hoàn thành',
    totalUsers: 'Tổng số người dùng',
    totalPackages: 'Tổng số gói hàng',
    activePackages: 'Gói hàng đang hoạt động',
    deliveredToday: 'Đã giao hôm nay',
    totalCells: 'Tổng số ô',
    cellsUsage: 'Ô đang sử dụng',
    averageDailyUsage: 'Sử dụng trung bình',
    cellsUsageChart: 'Biểu đồ sử dụng ô',
    recentPackages: 'Gói hàng gần đây',
    activeUsers: 'Người dùng đang hoạt động',
    lastActive: 'Hoạt động lần cuối',
    lockedPackages: 'Gói đang hoạt động',
    expiredPackages: 'Đã hết hạn',
    finishedPackages: 'Đã hoàn thành',
    currentlyStored: 'Đang lưu trữ',
    storageExpired: 'Đã hết hạn lưu trữ',
    successfullyDelivered: 'Đã giao thành công',
    users: 'người dùng',
    occupancyChart: 'Lịch sử sử dụng tủ',
    periodSelector: {
      last30Days: '30 ngày qua',
      last60Days: '60 ngày qua',
      last90Days: '90 ngày qua'
    },
    cellsStatus: 'Trạng thái ô',
    activeCells: 'Hoạt động',
    brokenCells: 'Hỏng',
    occupiedCells: 'Đã sử dụng',
    reservedCells: 'Đã đặt trước',
    lockersStatus: 'Trạng thái tủ',
    totalLockers: 'Tổng số tủ',
    onlineLockers: 'Trực tuyến',
    offlineLockers: 'Ngoại tuyến',
    maintenanceLockers: 'Bảo trì',
    errorLockers: 'Lỗi'
  },
  menu: {
    users: 'Người dùng',
    packages: 'Gói hàng',
    settings: 'Cài đặt'
  },
  users: {
    title: 'Người dùng',
    add: 'Thêm mới',
    confirmDelete: 'Xác nhận xóa',
    confirmDeleteText: 'Bạn có chắc chắn muốn xóa người dùng này không?',
    createSuccess: 'Tạo người dùng thành công',
    createError: 'Không thể tạo người dùng',
    phoneExists: 'Người dùng với số điện thoại này đã tồn tại',
    deleteSuccess: 'Xóa người dùng thành công',
    deleteError: 'Không thể xóa người dùng',
    communities: 'Cộng đồng',
    search: 'Tìm kiếm theo tên',
    communityFilter: 'Lọc theo cộng đồng',
    statusFilter: 'Lọc theo trạng thái',
    createTitle: 'Tạo người dùng',
    editTitle: 'Chỉnh sửa người dùng',
    email: 'Email',
    phone: 'Điện thoại',
    fullName: 'Họ và tên',
    firstName: 'Tên',
    lastName: 'Họ',
    password: 'Mật khẩu',
    passwordHint: 'Để trống nếu không thay đổi',
    role: 'Vai trò',
    status: 'Trạng thái',
    coinBalance: 'Số dư coin',
    isActive: 'Người dùng đang hoạt động',
    dateJoined: 'Ngày đăng ký',
    actions: 'Hành động',
    edit: 'Chỉnh sửa',
    delete: 'Xóa',
    statuses: {
      active: 'Hoạt động',
      inactive: 'Không hoạt động'
    },
    topupBalance: 'Nạp tiền',
    topupFor: 'Nạp tiền cho',
    coinsAmount: 'Số lượng coin',
    topupSuccess: 'Nạp tiền thành công',
    topupError: 'Không thể nạp tiền'
  },
  packages: {
    title: 'Gói hàng',
    add: 'Thêm',
    search: 'Tìm kiếm',
    statusFilter: 'Lọc theo trạng thái',
    typeFilter: 'Lọc theo loại',
    id: 'ID',
    device: 'Thiết bị',
    cell: 'Ô',
    sender: 'Người gửi',
    recipient: 'Người nhận',
    createdAt: 'Ngày tạo',
    status: 'Trạng thái',
    type: 'Loại',
    details: 'Chi tiết',
    detailsTitle: 'Chi tiết gói hàng',
    expiresAt: 'Hết hạn vào',
    price: 'Giá',
    courier: 'Người giao hàng',
    basicInfo: 'Thông tin cơ bản',
    contactInfo: 'Thông tin liên hệ',
    locationInfo: 'Thông tin vị trí',
    community: 'Cộng đồng',
    notFound: 'Không tìm thấy gói hàng',
    notFoundText: 'Gói hàng bạn đang tìm kiếm không tồn tại hoặc đã bị xóa.',
    backToList: 'Quay lại danh sách gói hàng',
    statuses: {
      all: 'Tất cả trạng thái',
      new: 'Mới',
      locked: 'Đã khóa',
      finished: 'Hoàn thành',
      canceled: 'Đã hủy',
      expired: 'Hết hạn'
    },
    types: {
      delivery: 'Giao hàng',
      storage: 'Lưu trữ',
      shared: 'Chia sẻ'
    },
    eventsHistory: 'Lịch sử sự kiện',
    eventTypes: {
      cell_was_opened: 'Ô đã được mở',
      cell_was_closed: 'Ô đã được đóng',
      parcel_created: 'Gói hàng đã được tạo',
      parcel_updated: 'Gói hàng đã được cập nhật',
      parcel_expired: 'Gói hàng đã hết hạn',
      parcel_finished: 'Gói hàng đã hoàn thành',
      parcel_canceled: 'Gói hàng đã bị hủy',
      cell_photo_was_received: 'Ảnh'
    },
    dateFilter: 'Lọc theo ngày tạo',
    startDateFilter: 'Từ ngày',
    endDateFilter: 'Đến ngày'
  },
  settings: {
    title: 'Cài đặt',
    profileInfo: 'Thông tin cá nhân',
    appSettings: 'Cài đặt ứng dụng',
    email: 'Email',
    fullName: 'Họ và tên',
    notSpecified: 'Chưa được chỉ định',
    role: 'Vai trò',
    language: 'Ngôn ngữ hệ thống',
    dateJoined: 'Ngày đăng ký',
    theme: 'Giao diện',
    roles: {
      administrator: 'Quản trị viên',
      manager: 'Quản lý',
      customer: 'Khách hàng'
    },
    notifications: {
      email: 'Thông báo Email',
      sms: 'Thông báo SMS'
    },
    save: 'Lưu cài đặt',
    tariffs: 'Biểu phí',
    noTariffsData: 'Thông tin biểu phí không khả dụng',
    freeMinutes: 'Thời gian miễn phí',
    pricePerHour: 'Giá mỗi giờ',
    pricePerDay: 'Giá mỗi ngày',
    minutes: 'phút',
    currency: '₽',
    communities: 'Cộng đồng',
    communitySettings: 'Cài đặt cộng đồng',
    confirmSaveTitle: 'Xác nhận thay đổi',
    confirmSaveText: 'Bạn có chắc chắn muốn lưu những thay đổi này không?',
    noCommunities: 'Không có cộng đồng nào',
    selectCommunity: 'Chọn cộng đồng',
    generalSection: 'Cài đặt chung',
    limitsSection: 'Cài đặt giới hạn',
    pricingSection: 'Cài đặt giá',
    communityName: 'Tên cộng đồng',
    communityAddress: 'Địa chỉ',
    autoApproveUsers: 'Tự động phê duyệt người dùng',
    maxCellsPerCustomer: 'Số ô tối đa mỗi khách hàng',
    maxCellsPerCustomerHint: 'Số ô tối đa cho phép mỗi khách hàng',
    maxDeliveryHours: 'Giờ giao hàng tối đa',
    maxDeliveryHoursHint: 'Số giờ tối đa cho lưu trữ giao hàng',
    maxStorageHours: 'Giờ lưu trữ tối đa',
    maxStorageHoursHint: 'Số giờ tối đa cho thuê ô',
    minStorageHours: 'Giờ lưu trữ tối thiểu',
    minStorageHoursHint: 'Số giờ tối thiểu cho thuê ô',
    maxSharingHours: 'Giờ chia sẻ tối đa',
    maxSharingHoursHint: 'Số giờ tối đa cho phép chia sẻ ô',
    deliveryHourlyPrice: 'Giá theo giờ giao hàng',
    deliveryHourlyPriceHint: 'Giá mỗi giờ cho lưu trữ giao hàng',
    storageHourlyPrice: 'Giá theo giờ lưu trữ',
    storageHourlyPriceHint: 'Giá mỗi giờ cho thuê ô',
    sharingHourlyPrice: 'Giá theo giờ chia sẻ',
    sharingHourlyPriceHint: 'Giá mỗi giờ cho chia sẻ ô',
    freeDeliveryHours: 'Giờ giao hàng miễn phí',
    freeDeliveryHoursHint: 'Số giờ miễn phí cho giao hàng đến',
    freeStorageHours: 'Giờ lưu trữ miễn phí',
    freeStorageHoursHint: 'Số giờ lưu trữ miễn phí',
    freeSharingHours: 'Giờ chia sẻ miễn phí',
    freeSharingHoursHint: 'Số giờ chia sẻ miễn phí',
    priceBySlot: 'Giá theo ô',
    priceBySlotHint: 'Giá được thiết lập cho từng ô riêng lẻ'
  },
  common: {
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    create: 'Tạo',
    save: 'Lưu',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    add: 'Thêm',
    search: 'Tìm kiếm',
    filter: 'Lọc',
    reset: 'Đặt lại',
    loading: 'Đang tải...',
    noData: 'Không có dữ liệu',
    unknownUser: 'Người dùng không xác định',
    copied: '{field} đã được sao chép vào bộ nhớ tạm',
    copyError: 'Không thể sao chép vào bộ nhớ tạm',
    close: 'Đóng',
    error: 'Lỗi',
    success: 'Thành công',
    warning: 'Cảnh báo',
    info: 'Thông tin',
    ok: 'OK',
    pagination: {
      showing: "Hiển thị",
      of: "của",
      perPage: "mỗi trang"
    }
  },
  validation: {
    required: 'Trường này là bắt buộc',
    phone: 'Nhập số theo định dạng quốc tế',
    minLength: 'Độ dài tối thiểu: {min} ký tự',
    maxLength: 'Độ dài tối đa: {max} ký tự',
    minValue: 'Giá trị tối thiểu: {min}',
    maxValue: 'Giá trị tối đa: {max}'
  },
  locker: {
    title: 'Community Locker',
    slogan: 'Dễ dàng gửi, nhận hoặc chia sẻ bưu kiện với cộng đồng của bạn. Không xếp hàng, không phiền phức — chỉ đơn giản là giao hàng an toàn trong tầm tay.',
    downloadTitle: 'Tải xuống ứng dụng của chúng tôi',
    appStore: 'Tải xuống trên App Store',
    googlePlay: 'Tải xuống trên Google Play',
    copyright: '© 2025. Tất cả quyền được bảo lưu.'
  },
  pickup: {
    title: 'Nhận gói hàng',
    description: 'Quét mã QR bên dưới để nhận gói hàng từ tủ khóa.',
    code: 'Mã gói hàng',
    qrCodeAlt: 'Mã QR để nhận gói hàng',
    generating: 'Đang tạo mã QR...',
    download: 'Tải xuống mã QR'
  }
} 